module.exports = __webpack_public_path__ + "img/pro1.ace652c9.png";